import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetLocationBusinessHoursQueryVariables = Types.Exact<{
  locationId: Types.Scalars['bigint']['input'];
}>;


export type GetLocationBusinessHoursQuery = { __typename?: 'query_root', businesshours: Array<{ __typename?: 'businesshours', id: number, name: string, type: string, location_id?: number | null, day?: number | null, month?: number | null, year?: number | null, day_of_week?: number | null, week_of_month?: number | null, is_open: boolean, open_time?: any | null, closed_time?: any | null, created_by: string, updated_by: string, created_at: string, updated_at: string }> };

export type CreateBusinessHoursMutationVariables = Types.Exact<{
  businessHours: Array<Types.Businesshours_Insert_Input> | Types.Businesshours_Insert_Input;
}>;


export type CreateBusinessHoursMutation = { __typename?: 'mutation_root', insert_businesshours?: { __typename?: 'businesshours_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'businesshours', id: number, name: string, type: string, location_id?: number | null, day?: number | null, month?: number | null, year?: number | null, day_of_week?: number | null, week_of_month?: number | null, is_open: boolean, open_time?: any | null, closed_time?: any | null }> } | null };

export type UpdateBusinessHoursMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
  input: Types.Businesshours_Set_Input;
}>;


export type UpdateBusinessHoursMutation = { __typename?: 'mutation_root', update_businesshours?: { __typename?: 'businesshours_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'businesshours', id: number, name: string, type: string, location_id?: number | null, day?: number | null, month?: number | null, year?: number | null, day_of_week?: number | null, week_of_month?: number | null, is_open: boolean, open_time?: any | null, closed_time?: any | null }> } | null };

export type DeleteBusinessHoursMutationVariables = Types.Exact<{
  id: Types.Scalars['bigint']['input'];
}>;


export type DeleteBusinessHoursMutation = { __typename?: 'mutation_root', delete_businesshours?: { __typename?: 'businesshours_mutation_response', affected_rows: number } | null };


export const GetLocationBusinessHoursDocument = gql`
    query GetLocationBusinessHours($locationId: bigint!) {
  businesshours(
    where: {_or: [{location_id: {_eq: $locationId}}, {type: {_in: ["default-hours"]}}]}
    order_by: [{day_of_week: asc}, {open_time: asc}]
  ) {
    id
    name
    type
    location_id
    day
    month
    year
    day_of_week
    week_of_month
    is_open
    open_time
    closed_time
    created_by
    updated_by
    created_at
    updated_at
  }
}
    `;

/**
 * __useGetLocationBusinessHoursQuery__
 *
 * To run a query within a React component, call `useGetLocationBusinessHoursQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationBusinessHoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationBusinessHoursQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetLocationBusinessHoursQuery(baseOptions: Apollo.QueryHookOptions<GetLocationBusinessHoursQuery, GetLocationBusinessHoursQueryVariables> & ({ variables: GetLocationBusinessHoursQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationBusinessHoursQuery, GetLocationBusinessHoursQueryVariables>(GetLocationBusinessHoursDocument, options);
      }
export function useGetLocationBusinessHoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationBusinessHoursQuery, GetLocationBusinessHoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationBusinessHoursQuery, GetLocationBusinessHoursQueryVariables>(GetLocationBusinessHoursDocument, options);
        }
// @ts-ignore
export function useGetLocationBusinessHoursSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetLocationBusinessHoursQuery, GetLocationBusinessHoursQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationBusinessHoursQuery, GetLocationBusinessHoursQueryVariables>;
export function useGetLocationBusinessHoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationBusinessHoursQuery, GetLocationBusinessHoursQueryVariables>): Apollo.UseSuspenseQueryResult<GetLocationBusinessHoursQuery | undefined, GetLocationBusinessHoursQueryVariables>;
export function useGetLocationBusinessHoursSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLocationBusinessHoursQuery, GetLocationBusinessHoursQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLocationBusinessHoursQuery, GetLocationBusinessHoursQueryVariables>(GetLocationBusinessHoursDocument, options);
        }
export type GetLocationBusinessHoursQueryHookResult = ReturnType<typeof useGetLocationBusinessHoursQuery>;
export type GetLocationBusinessHoursLazyQueryHookResult = ReturnType<typeof useGetLocationBusinessHoursLazyQuery>;
export type GetLocationBusinessHoursSuspenseQueryHookResult = ReturnType<typeof useGetLocationBusinessHoursSuspenseQuery>;
export type GetLocationBusinessHoursQueryResult = Apollo.QueryResult<GetLocationBusinessHoursQuery, GetLocationBusinessHoursQueryVariables>;
export const CreateBusinessHoursDocument = gql`
    mutation CreateBusinessHours($businessHours: [businesshours_insert_input!]!) {
  insert_businesshours(objects: $businessHours) {
    affected_rows
    returning {
      id
      name
      type
      location_id
      day
      month
      year
      day_of_week
      week_of_month
      is_open
      open_time
      closed_time
    }
  }
}
    `;
export type CreateBusinessHoursMutationFn = Apollo.MutationFunction<CreateBusinessHoursMutation, CreateBusinessHoursMutationVariables>;

/**
 * __useCreateBusinessHoursMutation__
 *
 * To run a mutation, you first call `useCreateBusinessHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessHoursMutation, { data, loading, error }] = useCreateBusinessHoursMutation({
 *   variables: {
 *      businessHours: // value for 'businessHours'
 *   },
 * });
 */
export function useCreateBusinessHoursMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessHoursMutation, CreateBusinessHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBusinessHoursMutation, CreateBusinessHoursMutationVariables>(CreateBusinessHoursDocument, options);
      }
export type CreateBusinessHoursMutationHookResult = ReturnType<typeof useCreateBusinessHoursMutation>;
export type CreateBusinessHoursMutationResult = Apollo.MutationResult<CreateBusinessHoursMutation>;
export type CreateBusinessHoursMutationOptions = Apollo.BaseMutationOptions<CreateBusinessHoursMutation, CreateBusinessHoursMutationVariables>;
export const UpdateBusinessHoursDocument = gql`
    mutation UpdateBusinessHours($id: bigint!, $input: businesshours_set_input!) {
  update_businesshours(where: {id: {_eq: $id}}, _set: $input) {
    affected_rows
    returning {
      id
      name
      type
      location_id
      day
      month
      year
      day_of_week
      week_of_month
      is_open
      open_time
      closed_time
    }
  }
}
    `;
export type UpdateBusinessHoursMutationFn = Apollo.MutationFunction<UpdateBusinessHoursMutation, UpdateBusinessHoursMutationVariables>;

/**
 * __useUpdateBusinessHoursMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessHoursMutation, { data, loading, error }] = useUpdateBusinessHoursMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessHoursMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessHoursMutation, UpdateBusinessHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessHoursMutation, UpdateBusinessHoursMutationVariables>(UpdateBusinessHoursDocument, options);
      }
export type UpdateBusinessHoursMutationHookResult = ReturnType<typeof useUpdateBusinessHoursMutation>;
export type UpdateBusinessHoursMutationResult = Apollo.MutationResult<UpdateBusinessHoursMutation>;
export type UpdateBusinessHoursMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessHoursMutation, UpdateBusinessHoursMutationVariables>;
export const DeleteBusinessHoursDocument = gql`
    mutation DeleteBusinessHours($id: bigint!) {
  delete_businesshours(where: {id: {_eq: $id}}) {
    affected_rows
  }
}
    `;
export type DeleteBusinessHoursMutationFn = Apollo.MutationFunction<DeleteBusinessHoursMutation, DeleteBusinessHoursMutationVariables>;

/**
 * __useDeleteBusinessHoursMutation__
 *
 * To run a mutation, you first call `useDeleteBusinessHoursMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBusinessHoursMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBusinessHoursMutation, { data, loading, error }] = useDeleteBusinessHoursMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBusinessHoursMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBusinessHoursMutation, DeleteBusinessHoursMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBusinessHoursMutation, DeleteBusinessHoursMutationVariables>(DeleteBusinessHoursDocument, options);
      }
export type DeleteBusinessHoursMutationHookResult = ReturnType<typeof useDeleteBusinessHoursMutation>;
export type DeleteBusinessHoursMutationResult = Apollo.MutationResult<DeleteBusinessHoursMutation>;
export type DeleteBusinessHoursMutationOptions = Apollo.BaseMutationOptions<DeleteBusinessHoursMutation, DeleteBusinessHoursMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/settings/gql/businessHours.gql}
 */
export async function createBusinessHours(
  variables: CreateBusinessHoursMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<CreateBusinessHoursMutation['insert_businesshours']>
export async function createBusinessHours(
  variables: CreateBusinessHoursMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<CreateBusinessHoursMutation>
export async function createBusinessHours(
  variables: CreateBusinessHoursMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<CreateBusinessHoursMutation['insert_businesshours'] | CreateBusinessHoursMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<CreateBusinessHoursMutation>(
    CreateBusinessHoursDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_businesshours
}

/**
 * @source {@link src/features/settings/gql/businessHours.gql}
 */
export async function deleteBusinessHours(
  variables: DeleteBusinessHoursMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<DeleteBusinessHoursMutation['delete_businesshours']>
export async function deleteBusinessHours(
  variables: DeleteBusinessHoursMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<DeleteBusinessHoursMutation>
export async function deleteBusinessHours(
  variables: DeleteBusinessHoursMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<DeleteBusinessHoursMutation['delete_businesshours'] | DeleteBusinessHoursMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<DeleteBusinessHoursMutation>(
    DeleteBusinessHoursDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.delete_businesshours
}

/**
 * @source {@link src/features/settings/gql/businessHours.gql}
 */
export async function getLocationBusinessHours(
  variables: GetLocationBusinessHoursQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetLocationBusinessHoursQuery['businesshours']>
export async function getLocationBusinessHours(
  variables: GetLocationBusinessHoursQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetLocationBusinessHoursQuery>
export async function getLocationBusinessHours(
  variables: GetLocationBusinessHoursQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetLocationBusinessHoursQuery['businesshours'] | GetLocationBusinessHoursQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetLocationBusinessHoursQuery>(
    GetLocationBusinessHoursDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.businesshours
}

/**
 * @source {@link src/features/settings/gql/businessHours.gql}
 */
export async function updateBusinessHours(
  variables: UpdateBusinessHoursMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateBusinessHoursMutation['update_businesshours']>
export async function updateBusinessHours(
  variables: UpdateBusinessHoursMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateBusinessHoursMutation>
export async function updateBusinessHours(
  variables: UpdateBusinessHoursMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateBusinessHoursMutation['update_businesshours'] | UpdateBusinessHoursMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateBusinessHoursMutation>(
    UpdateBusinessHoursDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_businesshours
}